// extracted by mini-css-extract-plugin
export default {"Table":"Table_Table__hwyVo"};